import { render, staticRenderFns } from "./insurance.vue?vue&type=template&id=97d85d4c"
import script from "./insurance.vue?vue&type=script&lang=js"
export * from "./insurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports